/* @flow */
import * as React from 'react';

import './divider.css';

export function Or() {
    return <div styleName='divider'>or</div>;
}
